import React from "react";
import styles from "./WarningIcon.scss";

export const WarningIcon = () => {
    return (
        <div className={styles.base}>
            <svg className={styles.exclamation} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className={styles.circle} cx="26" cy="26" r="25" fill="none" />
                <path className={styles.exclamationLine} fill="none" d="M26 10v20" />
                <circle className={styles.exclamationDot} cx="26" cy="38" r="2" fill="none" />
            </svg>
        </div>
    );
};
